module.exports = function(str) {
  let classString = str.replace(/ /g, '-'); // replace empty spaces with - for state names with two words (e.g. new mexico)
  return classString.toLowerCase();
};
